exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "section[_v-1e52a21d]:not(:first-child){padding-top:0}@media (max-width:767px){section[_v-1e52a21d]{padding:16px}section[_v-1e52a21d]:last-child{padding-bottom:16px}}button.btn[_v-1e52a21d]{display:-webkit-box;display:-ms-flexbox;font-weight:700;background:none;display:flex;font-size:14px}button.btn span[_v-1e52a21d]{line-height:3em;margin-left:10px}.container[_v-1e52a21d]{margin-top:50px}.container .col-xs-3[_v-1e52a21d]{margin-top:5px}.container h1[_v-1e52a21d]{margin-top:0}@media (max-width:767px){.container[_v-1e52a21d]{margin-top:0;margin-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1e52a21d&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=1!./assets/component/about/corporate-governance.vue
// module id = 292
// module chunks = 0